module.exports = __webpack_public_path__ + "img/tracktemi.15804168.png";